<template>
    <div :class="containerClass">
        <PInputText
            :id="inputId"
            ref="input"
            :aria-controls="(panelProps && panelProps.id) || panelId || panelUniqueId"
            :aria-expanded="overlayVisible"
            :aria-haspopup="true"
            :aria-label="ariaLabel"
            :aria-labelledby="ariaLabelledby"
            :autocomplete="autocomplete"
            :class="inputClass"
            :placeholder="placeholder"
            :required="required"
            :style="inputStyle"
            :type="inputType"
            :value="modelValue"
            v-bind="inputProps"
            @blur="onBlur"
            @focus="onFocus"
            @input="onInput"
            @invalid="onInvalid"
            @keyup="onKeyUp"
        />
        <i v-if="toggleMask" :class="toggleIconClass" @click="onMaskToggle"/>
        <span aria-live="polite" class="p-hidden-accessible">
            {{ infoText }}
        </span>
        <Portal :appendTo="appendTo">
            <transition name="p-connected-overlay" @enter="onOverlayEnter" @leave="onOverlayLeave"
                        @after-leave="onOverlayAfterLeave">
                <div v-if="overlayVisible" :id="panelId || panelUniqueId" :ref="overlayRef" :class="panelStyleClass"
                     :style="panelStyle" v-bind="panelProps" @click="onOverlayClick">
                    <slot name="header"></slot>
                    <slot name="content">
                        <div class="p-password-meter">
                            <div :class="strengthClass" :style="{ width: meter ? meter.width : '' }"></div>
                        </div>
                        <div class="p-password-info">{{ infoText }}</div>
                    </slot>
                    <slot name="footer"></slot>
                </div>
            </transition>
        </Portal>
    </div>
</template>

<script>
import Password from "primevue/password";
import InputText from "./InputText";

export default {
    name: "Password",
    props: {
        autocomplete: null,
    },
    extends: Password,
    components: {
        'PInputText': InputText
    }
}
</script>

<style scoped>

</style>